import { createApiActionTypes } from 'iqvia-shared';

import { types } from '../actions';
import apiNameEnums from '../../Enums/apiNames';

const defaultState = {
  tokens: { fuel2token: '' },
  interaction: {},
  activity: { arguments: { execute: { inArguments: [] } } },
  steps: { key: 'step1', index: 0 },
  metaData: { hasValue: true },
  isLoading: true,
};

export const journeyBuilderInitialize = createApiActionTypes(apiNameEnums.POST_INITIALIZE);

export const journeyBuilderGetMetadataActionTypes = createApiActionTypes(
  apiNameEnums.GET_JOURNEY_METADATA
);

export default (state = defaultState, { type, payload }) => {
  switch (type) {
    case types.JOURNEY_BUILDER_SET_TOKEN:
      return {
        ...state,
        tokens: payload.tokens,
      };
    case types.JOURNEY_BUILDER_SET_INTERACTION:
      return {
        ...state,
        interaction: payload.interaction,
      };
    case types.JOURNEY_BUILDER_SET_ACTIVITY:
      return {
        ...state,
        activity: payload.activity,
      };
    case types.JOURNEY_BUILDER_SET_STEP:
      return {
        ...state,
        steps: payload.steps,
      };
    case journeyBuilderGetMetadataActionTypes.success.type:
      return {
        ...state,
        metaData: payload,
        isLoading: false,
      };
    case journeyBuilderInitialize.request.type:
    case journeyBuilderGetMetadataActionTypes.request.type:
      return {
        ...state,
        isLoading: true,
      };
    case journeyBuilderInitialize.success.type:
    case journeyBuilderInitialize.failure.type:
    case journeyBuilderGetMetadataActionTypes.failure.type:
      return {
        ...state,
        isLoading: false,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/Root/reducers/Root.js